import {to} from 'await-to-js';
import {isEmpty, get, map, compact, fromPairs} from 'lodash';
import jwt from 'jsonwebtoken';
import { defineStore } from 'pinia'
import {toRaw} from "vue";
import { interceptor } from "@dutypay/utilities";

export const useAuthStore = defineStore('authStore', {
    state: () => {
        return {
            status: '',
            refreshToken: localStorage.getItem('refreshToken') || '',
            accessToken: localStorage.getItem('accessToken') || '',
            user: null,
            isUserFetched: false
        }
    },
    getters: {
        isLoggedIn: (state) => Boolean(state.token),
        hasUserName: (state) => !isEmpty(toRaw(state.user)) && !isEmpty(get(toRaw(state.user), 'name', undefined)),
    },
    actions: {
        //This is used for authentication with one time token from URL for HubSystem Applications
        async tokenAuth(){
            //Check for URL onetime token
            let urlHash = window.location.hash;
            let urlParams = fromPairs(compact(map(urlHash.slice(1).split('&'), function(item) {if (item) return item.split('=');})));
            let token = (urlParams.token ? decodeURIComponent(urlParams.token) : false) || localStorage.getItem('accessToken');
            let refreshToken = localStorage.getItem('refreshToken') || '';
            if (!token && !refreshToken) {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                return window.location = `${process.env.VUE_APP_HOST_SSO}/login?redirect=${document.URL}`;
            }
            let err, tokens;
            [err, tokens] =  await to(interceptor({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/authenticate/token`,
                headers: {
                    "Authorization": "Bearer " + token
                },
                method: 'POST'
            }))
            if (err){
                this.status = 'error';
                this.refreshToken = ''
                this.accessToken = ''
                this.user = {}
                this.isUserFetched = false
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                return window.location = `${process.env.VUE_APP_HOST_SSO}/login?redirect=${document.URL}`;
            }
            tokens = tokens.data
            localStorage.setItem('accessToken', tokens.accessToken);
            localStorage.setItem('refreshToken', tokens.refreshToken);
            interceptor.defaults.headers.common.Authorization = "Bearer " + localStorage.getItem('accessToken');

            let payload = jwt.decode(tokens.accessToken);
            let user;
            [err, user] = await to(interceptor({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/users/${payload.hs.user.id}`,
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem('accessToken')
                },
                method: 'GET'
            }))

            if (err){
                this.status = 'error';
                this.refreshToken = ''
                this.accessToken = ''
                this.user = {}
                this.isUserFetched = false
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                return window.location = `${process.env.VUE_APP_HOST_SSO}/login?redirect=${document.URL}`;
            }

            this.status = 'success';
            this.refreshToken = tokens.refreshToken;
            this.accessToken = tokens.accessToken;
            this.user = user.data;
            this.isUserFetched = true;

            history.pushState("", document.title, window.location.pathname + window.location.search);
            return user;
        },
        async validate(tokens){
            let err, user, payload;
            [err, payload] =  await to(interceptor({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/validate`,
                headers: {
                    "Authorization": "Bearer " + ( (!!tokens && !!tokens.accessToken) ? tokens.accessToken : localStorage.getItem('accessToken') )
                },
                method: 'POST'
            }))
            if (err){
                this.status = 'error';
                this.refreshToken = '';
                this.accessToken = '';
                this.user = {};
                this.isUserFetched = false;
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                return false;
            }

            let userId = get(payload.data, 'hs.user.id');

            [err, user] = await to(interceptor({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/users/${userId}`,
                headers: {
                    "Authorization": "Bearer " + ( (!!tokens && !!tokens.accessToken) ? tokens.accessToken : localStorage.getItem('accessToken') )
                },
                method: 'GET'
            }))

            if(err){
                this.status = 'error';
                this.refreshToken = '';
                this.accessToken = '';
                this.user = {};
                this.isUserFetched = false;
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                return false;
            }

            this.status = 'success';
            this.refreshToken = localStorage.getItem('refreshToken');
            this.accessToken = localStorage.getItem('accessToken');
            this.user = user.data;
            this.isUserFetched = true;

            return user;

        },
        async logout(){
            const logout = await to(interceptor({
                url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/logout`,
                method: 'POST'
            }));
            this.status = '';
            this.refreshToken = '';
            this.accessToken = '';
            this.user = {};
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            delete interceptor.defaults.headers.common.Authorization;
            return logout;
        }
    }
})
